import {Component, ElementRef, EventEmitter, Output, ViewChild} from '@angular/core';
import {DeliveryService} from "../../../../services/delivery.service";
import {
  MessageDeliveryBrojkoConfirmComponent
} from "../../messages/message-delivery-brojko-confirm/message-delivery-brojko-confirm.component";
import {HttpClient} from "@angular/common/http";
import {LocalStorageService} from "../../../../services/local-storage.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-pickup-brojka',
  templateUrl: './pickup-brojka.component.html',
  styleUrls: ['../../../basket-confirm/basket-confirm.component.scss']
})
export class PickupBrojkaComponent extends DeliveryService {
  @ViewChild('scrollInputRef') scrollInputRef: ElementRef<HTMLInputElement>;
  @ViewChild(MessageDeliveryBrojkoConfirmComponent) messageDeliveryBrojkoConfirmComponentRef: MessageDeliveryBrojkoConfirmComponent;
  @Output() selectedDeliveryType = new EventEmitter<number>();

  constructor(
    http: HttpClient,
    localStorage: LocalStorageService,
    private router: Router
  ) {
    super(http, localStorage);
  }

  override scrollToInvalidForm() {
    if (this.wrongDeliveryDates) {
      this.scrollInputRef.nativeElement.scrollIntoView();
    }
  }

  changingValueDeliveryDate() {
    if (this.deliveryDate == -1 && !this.dozakazDate) {
      this.wrongDeliveryDates = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongDeliveryDates = false;
    }
  }

  switchesDeliveryType(id: number) {
    this.selectedDeliveryType.emit(id);
  }

  override validateSendPayment() {
    this.isValidDeliveryForm = false;
    const sendData = {
      delivery_id: this.delivery
    };

    this.changingValueDeliveryDate();

    sendData['delivery_date'] = this.deliveryDate;
    sendData['comment'] = this.deliveryComment;

    // Дати переміщення бек рахує лише по підзамовних товарах: для кошика зі складів 1+7 без них список
    // порожній, а вибір обов'язковий - форма не відправлялась. Без delivery_date_zak бек бере delivery_date.
    if (this.separateOrders && this.deliveryCurrent?.delivery_dates_zak?.length) {
      this.changingValueDeliverySeparate();

      sendData['delivery_date_zak'] = this.deliverySeparate;
    }

    return sendData;
  }

  override resultSendPayment(data) {
    if (data.error === '' && data.data.order_id) {
      data.data.delivery = this.delivery;
      this.isDeliveryConfirmation = true;
      this.messageDeliveryBrojkoConfirmComponentRef.deliveryBrojkoConfirmationShow(data);
    }

    if (data.error === 'empty basket') {
      this.router.navigate(['account']);
    }

    if (data.error === 'too many orders') {
      this.router.navigate(['account']);
    }

    if (data.error === 'not_enough_liters') {
      this.router.navigate(['basket']);
    }
  }
}
